module.exports = __webpack_public_path__ + "img/placemakers-underconstruction-logo.0722ca2e.png";